import { render, staticRenderFns } from "./brave-new-ideas-proposals.vue?vue&type=template&id=7e14144d&scoped=true&"
import script from "./brave-new-ideas-proposals.vue?vue&type=script&lang=js&"
export * from "./brave-new-ideas-proposals.vue?vue&type=script&lang=js&"
import style0 from "./brave-new-ideas-proposals.vue?vue&type=style&index=0&id=7e14144d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e14144d",
  null
  
)

export default component.exports